import { render } from "./AppleMain.vue?vue&type=template&id=8cd619a2&lang=true"
import script from "./AppleMain.vue?vue&type=script&lang=js"
export * from "./AppleMain.vue?vue&type=script&lang=js"

import "./AppleMain.vue?vue&type=style&index=0&id=8cd619a2&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__